import SelectLocation from "./SelectLocation";
import styled from "styled-components";

export const STSelectLocation = styled(SelectLocation)`
  &&& {
    margin-bottom: 25px;
    min-width: 100%;
  }
`;

export const STItem = styled.div`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
